import React, { useState } from "react";
import "./addMedicalStore.css";

const AddMedicalStore = () => {
  const [storeData, setStoreData] = useState({
    name: "",
    dlNumber: "",
    gstNumber: "",
    address: "",
    mobile: "",
    storeImage: null,
    mapIframe: "",
  });
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setStoreData({ ...storeData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setStoreData({ ...storeData, storeImage: file });
      // Create preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Create FormData for file upload
      const formData = new FormData();
      formData.append("name", storeData.name.trim());
      formData.append("dlNumber", storeData.dlNumber.trim());
      formData.append("gstNumber", storeData.gstNumber.trim());
      formData.append("address", storeData.address.trim());
      formData.append("mobile", storeData.mobile.trim());
      formData.append("mapIframe", storeData.mapIframe.trim());
      if (storeData.storeImage) {
        formData.append("image", storeData.storeImage);
      }

      // Log formData to check what's being sent
      for (let pair of formData.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }

      const response = await fetch(
        "https://api.swasthmitra.com/api/stores/add", // Updated endpoint
        {
          method: "POST",
          body: formData,
          // Remove Content-Type header - let browser set it with boundary
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error adding store");
      }

      setMessage({
        text: "Medical Store added successfully!",
        type: "success",
      });
      // Clear form
      setStoreData({
        name: "",
        dlNumber: "",
        gstNumber: "",
        address: "",
        mobile: "",
        storeImage: null,
        mapIframe: "",
      });
      setImagePreview(null);
    } catch (error) {
      console.error("Error:", error);
      setMessage({
        text: error.message || "An error occurred. Please try again.",
        type: "error",
      });
    }

    setIsLoading(false);
  };

  return (
    <div className="form-container">
      <h2>Add Medical Store</h2>

      {message && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <form className="medical-store-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Store Name*</label>
          <input
            type="text"
            id="name"
            name="name"
            value={storeData.name}
            onChange={handleChange}
            placeholder="Enter store name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="dlNumber">Drug License Number</label>
          <input
            type="text"
            id="dlNumber"
            name="dlNumber"
            value={storeData.dlNumber}
            onChange={handleChange}
            placeholder="Enter DL number"
          />
        </div>

        <div className="form-group">
          <label htmlFor="gstNumber">GST Number</label>
          <input
            type="text"
            id="gstNumber"
            name="gstNumber"
            value={storeData.gstNumber}
            onChange={handleChange}
            placeholder="Enter GST number"
          />
        </div>

        <div className="form-group">
          <label htmlFor="mobile">Mobile Number</label>
          <input
            type="text"
            id="mobile"
            name="mobile"
            value={storeData.mobile}
            onChange={handleChange}
            placeholder="Enter mobile number"
          />
        </div>

        <div className="form-group">
          <label htmlFor="address">Address</label>
          <textarea
            id="address"
            name="address"
            value={storeData.address}
            onChange={handleChange}
            placeholder="Enter store address"
          />
        </div>

        <div className="form-group">
          <label htmlFor="mapIframe">Google Maps Embed Code</label>
          <textarea
            id="mapIframe"
            name="mapIframe"
            value={storeData.mapIframe}
            onChange={handleChange}
            placeholder="Paste Google Maps iframe code here"
            rows="4"
          />
          <small className="help-text">
            To get the embed code: 1. Go to Google Maps 2. Find your location 3.
            Click "Share" 4. Select "Embed a map" 5. Copy the iframe code
          </small>
          {storeData.mapIframe && (
            <div className="map-preview">
              <div dangerouslySetInnerHTML={{ __html: storeData.mapIframe }} />
            </div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="storeImage">Store Image</label>
          <input
            type="file"
            id="storeImage"
            name="storeImage"
            onChange={handleImageChange}
            accept="image/*"
          />
          {imagePreview && (
            <div className="image-preview">
              <img src={imagePreview} alt="Store preview" />
            </div>
          )}
        </div>

        <button type="submit" disabled={isLoading}>
          {isLoading ? "Adding Store..." : "Add Store"}
        </button>
      </form>
    </div>
  );
};

export default AddMedicalStore;
